// userSelectors.js

export const selectHealthRecords = (state) => state.healthRecord.healthRecords;
export const selectLoading = (state) => state.healthRecord.loading;
export const selectClickedHealthRecordId = (state) => state.healthRecord.healthId;
export const selectHealthRecordTypes = (state) => state.healthRecord.healthRecordTypes;
export const selectHealthRecordTypeSuccess = (state) => state.healthRecord.msg;
export const selectHealthRecordsPage = (state) => state.healthRecord.page;

